"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _auth0Js = _interopRequireDefault(require("auth0-js"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _queryString = _interopRequireDefault(require("query-string"));

var _api = require("../api");

var _config = require("../config");

var _index = require("./index");

var _appHistory = _interopRequireDefault(require("../appHistory"));

var _reducerUtil = _interopRequireDefault(require("../reducerUtil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var timer;
var auth;
var defaultLoginPage = '/login'; // Juni

var start = function start(authConfig, loginRequired, loginPage) {
  return function (dispatch) {
    if (auth) return;
    auth = new _auth0Js["default"].WebAuth(_objectSpread({
      responseType: 'token'
    }, authConfig));
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.loginRequired, loginRequired));
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.loginPage, loginPage || defaultLoginPage));
  };
};

var userLogin = function userLogin(username, password) {
  var authData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var token;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return new Promise(function (resolve, reject) {
                auth.client.login({
                  realm: 'Username-Password-Authentication',
                  scope: 'openid profile permissions',
                  redirectUri: "".concat(window.location.href, "?").concat(_queryString["default"].stringify(authData)),
                  username: username,
                  password: password
                }, function (error, result) {
                  return dispatch(authLogin(error, result, resolve, reject));
                });
              });

            case 3:
              token = _context.sent;
              if (token) dispatch(fromLogin());
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              dispatch(_config.actions.error(_context.t0));
              return _context.abrupt("return", _context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var socialLogin = function socialLogin(connection) {
  var authData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    auth.authorize({
      scope: 'openid profile permissions',
      redirectUri: "".concat(window.location.href, "?").concat(_queryString["default"].stringify(authData)),
      connection: connection
    });
  };
};

var googleLogin = function googleLogin(authData) {
  return function (dispatch) {
    return dispatch(socialLogin('google-oauth2', authData));
  };
};

var linkedInLogin = function linkedInLogin(authData) {
  return function (dispatch) {
    return dispatch(socialLogin('linkedin', authData));
  };
};

var checkLogin = function checkLogin() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, token, profile, loginPage, newToken, loginRequired;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              token = localStorage.getItem(_index.reducerData.token);
              profile = token && JSON.parse(localStorage.getItem(_index.reducerData.profile));

              if (!(token && profile && dispatch(setLogin(token, profile)))) {
                _context2.next = 6;
                break;
              }

              dispatch(fromLogin());
              return _context2.abrupt("return", true);

            case 6:
              loginPage = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.loginPage, state);

              if (!_appHistory["default"].location.pathname.includes(loginPage)) {
                _context2.next = 20;
                break;
              }

              _context2.prev = 8;
              _context2.next = 11;
              return new Promise(function (resolve, reject) {
                auth.parseHash(function (error, result) {
                  return dispatch(authLogin(error, result, resolve, reject));
                });
              });

            case 11:
              newToken = _context2.sent;

              if (!newToken) {
                _context2.next = 15;
                break;
              }

              dispatch(fromLogin());
              return _context2.abrupt("return", true);

            case 15:
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](8);
              dispatch(_config.actions.error(_context2.t0));

            case 20:
              loginRequired = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.loginRequired, state);
              if (loginRequired) dispatch(toLogin());

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 17]]);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var authLogin = function authLogin(error, result, resolve, reject) {
  return function (dispatch) {
    if (error) reject(error);else if (!result) resolve();else {
      var token = result.accessToken;
      auth.client.userInfo(token, function (err, profile) {
        if (err) reject(err);else if (!dispatch(setLogin(token, profile))) reject();else resolve(token);
      });
    }
  };
};

var setLogin = function setLogin(token, profile) {
  return function (dispatch) {
    if (dispatch(setLogOutTimer(token))) {
      localStorage.setItem(_index.reducerData.token, token);
      localStorage.setItem(_index.reducerData.profile, JSON.stringify(profile));
      dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.token, token));
      dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.profile, profile));
      return true;
    }
  };
};

var setLogOutTimer = function setLogOutTimer(token) {
  return function (dispatch) {
    if (token) {
      var decodedToken = (0, _jwtDecode["default"])(token);

      if (decodedToken) {
        var timeRemaining = decodedToken.exp * 1000 - Date.now();

        if (timeRemaining > 0) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            return dispatch(logOut());
          }, timeRemaining);
          return true;
        }
      }
    }

    dispatch(logOut());
  };
};

var logOut = function logOut() {
  return function (dispatch, getState) {
    if (timer) clearTimeout(timer);
    localStorage.removeItem(_index.reducerData.token);
    localStorage.removeItem(_index.reducerData.profile);
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.token, undefined));
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.profile, undefined));

    var loginRequired = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.loginRequired, getState());

    if (loginRequired) dispatch(toLogin());
  };
};

var logOutWithoutRedirect = function logOutWithoutRedirect() {
  return function (dispatch) {
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.token, undefined));
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.profile, undefined));
  };
};

var toLogin = function toLogin() {
  return function (dispatch, getState) {
    var loginPage = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.loginPage, getState());

    if (!_appHistory["default"].location.pathname.includes(loginPage)) {
      localStorage.setItem(_index.reducerData.lastPage, "".concat(_appHistory["default"].location.pathname).concat(_appHistory["default"].location.search));

      _appHistory["default"].push(loginPage);
    }
  };
};

var fromLogin = function fromLogin() {
  return function (dispatch, getState) {
    var loginPage = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.loginPage, getState());

    if (_appHistory["default"].location.pathname.includes(loginPage)) {
      var lastPage = localStorage.getItem(_index.reducerData.lastPage);

      _appHistory["default"].push(!lastPage || lastPage.includes(loginPage) ? '' : lastPage);
    }

    localStorage.removeItem(_index.reducerData.lastPage);
  };
};

var userSignUp = function userSignUp(username, password, tenantId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      var _window$location, hostname, origin, formattedError;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _window$location = window.location, hostname = _window$location.hostname, origin = _window$location.origin; // create user in auth0

              _context3.next = 4;
              return auth.signup({
                connection: 'Username-Password-Authentication',
                scope: 'openid profile permissions',
                email: username,
                password: password
              }, function (error) {
                if (error) return error;
              });

            case 4:
              _context3.next = 6;
              return dispatch(_api.actions.post('users/verification-link', {
                hostname: hostname,
                origin: origin,
                username: username,
                tenantId: tenantId
              }, true));

            case 6:
              _context3.next = 20;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!_context3.t0.description) {
                _context3.next = 14;
                break;
              }

              _context3.t1 = _context3.t0;
              _context3.next = 17;
              break;

            case 14:
              _context3.next = 16;
              return _context3.t0.json();

            case 16:
              _context3.t1 = _context3.sent;

            case 17:
              formattedError = _context3.t1;
              dispatch(_config.actions.error(formattedError));
              return _context3.abrupt("return", formattedError.message ? {
                description: formattedError.message
              } : formattedError);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var changePassword = function changePassword(_ref4) {
  var hostname = _ref4.hostname,
      origin = _ref4.origin,
      tenantId = _ref4.tenantId,
      username = _ref4.username;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return dispatch(_api.actions.post('users/password-link', {
                hostname: hostname,
                origin: origin,
                tenant_id: tenantId,
                username: username
              }, true));

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              dispatch(_config.actions.error(_context4.t0));
              return _context4.abrupt("return", _context4.t0);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 6]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var _default = {
  changePassword: changePassword,
  checkLogin: checkLogin,
  googleLogin: googleLogin,
  linkedInLogin: linkedInLogin,
  logOut: logOut,
  logOutWithoutRedirect: logOutWithoutRedirect,
  start: start,
  toLogin: toLogin,
  userLogin: userLogin,
  userSignUp: userSignUp
};
exports["default"] = _default;